import { ComponentHeadingSource, getComponentHeadingSource } from '@wix/a11y-adapters';
import { RuleId } from '@wix/a11y-rules';
import { convertElementStatusToBooleanStatus } from '@wix/rules-panel-ui';
import { useCallback } from 'react';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useGenericElement } from '../../../../hooks/use-generic-element';
export const useHeadingStructureAnalytics = _ref => {
  let {
    headingElements,
    pageId
  } = _ref;
  const biLogger = useBiLogger();
  const {
    isGenericElement,
    getComponent
  } = useGenericElement({
    getComponentStyleSource: getComponentHeadingSource,
    pageId,
    unknownValue: ComponentHeadingSource.UNKNOWN
  });
  const manualTaskDataEvent = useCallback(() => {
    const componentTypeMap = new Map();
    headingElements.forEach(element => {
      const {
        id
      } = element;
      const isGeneric = isGenericElement(id);
      let compType;
      try {
        ({
          type: compType
        } = getComponent(id));
      } catch (e) {
        console.error(e);
      }
      compType = compType || 'unknown';
      if (isGeneric) {
        if (!componentTypeMap.has(compType)) {
          componentTypeMap.set(compType, {
            element_count: 0,
            failed_element_count: 0
          });
        }
        const currentData = componentTypeMap.get(compType);
        const isElementFailed = !convertElementStatusToBooleanStatus(element.status);
        const updatedData = {
          element_count: currentData.element_count + 1,
          failed_element_count: isElementFailed ? currentData.failed_element_count + 1 : currentData.failed_element_count
        };
        componentTypeMap.set(compType, updatedData);
      }
    });
    const genericElementsData = Array.from(componentTypeMap.entries()).map(_ref2 => {
      let [compType, counts] = _ref2;
      return {
        comptype: compType,
        element_count: counts.element_count,
        failed_element_count: counts.failed_element_count
      };
    });
    const manualElementCount = genericElementsData.reduce((sum, item) => sum + item.element_count, 0);
    const manualFailedElementCount = genericElementsData.reduce((sum, item) => sum + item.failed_element_count, 0);
    const failedElementCount = headingElements.filter(element => element.failedReason !== undefined).length;
    biLogger.manualTaskData({
      elementCount: headingElements.length,
      failedElementCount,
      genericElementsData: JSON.stringify(genericElementsData),
      manualElementCount,
      manualFailedElementCount,
      taskName: RuleId.HEADING_STRUCTURE
    });
  }, [biLogger, getComponent, headingElements, isGenericElement]);
  return {
    manualTaskDataEvent
  };
};
//# sourceMappingURL=use-heading-structure-analytics.js.map